module.exports = __webpack_public_path__ + "img/29.3debb3e4.jpg";